import script from "./assetsResourcesPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./assetsResourcesPicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__